import React, {useState, useEffect} from 'react'
import { Link, useHistory } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faCheckCircle,
    faMoneyBillAlt,
    faPlusCircle,
    faSpinner,
    faUserCheck,
    faUserCircle 
} from '@fortawesome/free-solid-svg-icons'
import head2 from '../assets/images/head2.jpg'
import { 
    Beneficiary, CoinComponent, 
    Greet, 
    ShowWalletAdress, Transactions , Status
} from '../components/DashboardComponent'
import { getUser } from '../utils/profile';
import Navbar from '../components/Navbar'
import '../assets/css/dashboard.css'
import UploadId from '../components/modals/UploadID'
import Deposit from '../components/modals/DepositToWallets'
import AddBank from '../components/modals/AddBank'
import AddBeneficiary from '../components/modals/AddBeneficiary'
import PayBeneficiary from '../components/modals/PayBeneficiary'
import Remittance from '../components/Remittance'

const Dashboard = () => {
    const history = useHistory()
    if (!sessionStorage.getItem('idToken')) {
        history.push('/signin')
    }

    const [profile, setProfile] = useState(null)
    const [isPending, setIsPending] = useState(false)
    const [error, setError] = useState(null)

    const [showProfile, setShowProfile] = useState(true)
    const [showWallet, setShowWallet] = useState(false)

    const handleShowProfile = () => {
        setShowProfile(true)
        setShowWallet(false)
    }
    const handleShowWallet = () => {
        setShowProfile(false)
        setShowWallet(true)
    }
    const verifyStatus = {
        upload: true,
        bank: false,
        deposit: false,
    }
    const percentStatus = () => {
        let upload = verifyStatus.upload? 1: 0
        let bank = verifyStatus.bank?1:0
        let deposit=verifyStatus.deposit?1:0
        return Math.floor((upload+bank+deposit)/3*100)
    }

    useEffect(() => {
        document.title = 'Pouch | Dashboard'
        const fetchUser = async () => {
            setIsPending(true)
            let user = await getUser(sessionStorage.getItem('localId'))
            if (!user) {
              setError('Could not fetch user data')
            } else {
              if(user.code === 400) {
                setError(user.message || 'Could not fetch user data')
              } else {
                setProfile(user)
              }
            }
        }
        fetchUser()
        setIsPending(false)
        // eslint-disable-next-line
    }, [])

    if (error & !profile ) {
        return (
            <>
                <Navbar />
                <div>{error || 'Could not fetch data'}</div>
            </>
        )
    } else {
        if (isPending || !profile) {
            return (
                <div>
                    <Navbar />
                    <p className="d-flex align-items-center justify-content-center" style={{ minHeight: '80vh'}}>                    
                        <FontAwesomeIcon icon={faSpinner} spin className="h3 display-4" />
                    </p>
                </div>
            )
        } else {
            let transactions
            if(profile.transcations.arrayValue){ 
                transactions = profile.transcations.arrayValue.values
            }
            else{
                transactions = []
            }
            transactions = transactions.map(transaction => {
                transaction = transaction.mapValue.fields
                return {
                    type: transaction.type.stringValue,
                    transactionType: transaction.transcationType.stringValue,
                    amount: transaction.amount.integerValue,
                    date: transaction.date.timestampValue.seconds
                }

            })

            return (
                <>
                    <Navbar />
                    <div className="container p-2">
                        {/* Dashboard hero */}
                        <div className=" p-3" style={{borderRadius: '15px'}}>
                            <div className="row mx-1">
                                <Greet />
                                <div className="col-md text-right">
                                    <Link to="#" onClick={handleShowProfile}><FontAwesomeIcon icon={faUserCheck} className="text-purple h4 mx-2"/></Link>
                                    <Link to="#" onClick={handleShowWallet}><FontAwesomeIcon icon={faMoneyBillAlt} className="text-purple h4 mx-2"/></Link>
                                </div>
                            </div>
                            {showProfile && 
                            <div className="row d-flex justify-content-around mx-2 my-2 dash-card bg-1 text-white">
                                <div className="col-md p-3 h6 display-6">
                                    <h6 className="">
                                        <FontAwesomeIcon icon={faUserCircle} /> {profile.email.stringValue} 
                                        <span className="text-warning h6 small" style={{whiteSpace : 'nowrap'}}>
                                            <FontAwesomeIcon icon={faCheckCircle}  className="ml-md-2"/> Verified
                                        </span>
                                    </h6>
                                    <ShowWalletAdress />
                                </div>
                                <div className="col-md-5 p-3">
                                    <h6 className="border-bottom"><b>Profile Completion</b></h6>
                                    <div className="m-0">
                                        <div className="w-75 float-right mt-2 p-1" style={{background : '#ccc', borderRadius : '30px'}}>
                                            <div className="bg-success p-2" style={{width: `${percentStatus()}%`, borderRadius : '30px'}}></div>
                                        </div>
                                        <span className="h3">{percentStatus()}%</span>
                                    </div>
                                    <div className="w-100">
                                <div className="text-muted m-1 p-2" style={{maxWidth: '100%', overflowY: 'auto', whiteSpace : 'nowrap'}}>             
                                    <Status 
                                        Modal={<UploadId  title="Upload your NID" />}
                                        id="modalUploadID"
                                        title="Upload ID" 
                                        status={verifyStatus.upload? "success": "danger" }
                                        description="You uploaded NID"/>
                                    <Status 
                                        Modal={<AddBank />} 
                                        id="modalAddBank"
                                        title="Connect Bank Account" 
                                        status={verifyStatus.bank? "success": "danger" } 
                                        description="Connect Your bank accounts"/>
                                    <Status 
                                        Modal={<Deposit  title="Deposit Money" />} 
                                        id="modalDepositToWallets"
                                        title="Deposit Money"
                                        status={verifyStatus.deposit? "success": "danger" } 
                                        description="You can deposit from your bank"/>
                                    
                                </div>
                                    </div> 
                                </div>
                            </div>
                            }
                            {showWallet && 
                            <div className="row d-flex justify-content-around text-white">
                                <div className="col-md mx-4 p-3 dash-card bg-1 h6 display-6">
                                    <p className="float-md-left">
                                        <h2><span style={{textDecoration: 'double line-through'}}>N</span>{profile.balance.integerValue}</h2>
                                        <h6 className="text-light">${profile.balance.integerValue/500}</h6>
                                    </p>
                                    <div className="float-md-right row d-flex justify-content-around">
                                            {profile.coins && profile.coins.map((ele, idx) => <CoinComponent key={idx} price={ele.price} coin={ele.coin}/>)}
                                    </div>
                                </div>
                            </div>
                            }
                        </div>
                        <Remittance />

                        <hr className="bg-purple-shade" />
                        
                        {/* Balance history */}
                        <div className="my-3 shadow-lg row p-3">
                            <div className="col-12 py-2">
                                <div className="pb-3 m-0">
                                    <h3>Transactions</h3>
                                </div>
                                <div style={{ maxHeight : '180px', overflow : 'auto'}}>
                                    {transactions.map((transaction, idx) => {
                                        return (
                                            <Transactions
                                                key={idx}
                                                type={transaction.type}
                                                transactionType={transaction.transactionType}
                                                amount={transaction.amount}
                                                date={transaction.date}
                                            />
                                        )
                                    })}
                                </div>
                            </div>
                        </div>

                        {/* Contact and conversion */}
                        <div className="row p-2">
                            <div className="col-12 py-2">
                                <div className="m-1">
            
                                    <h3 className="py-1">Beneficiary</h3>
                                </div>
                                <hr className="bg-purple-shade" />
                                <span className="W-100 mt-4">
                                    <div className="text-muted m-1 p-4 contactSlide" style={{maxWidth: '100%', overflowY: 'auto', whiteSpace : 'nowrap'}}>             
                                        <button className="btn btn-dotted shadow text-center mx-2"> 
                                            <p className="m-0"><FontAwesomeIcon icon={faPlusCircle} className="h3 text-primary" /></p>
                                            <p className="m-0 text-muted"> Add</p>
                                            <p className="m-0 text-muted">Beneficiary</p>
                                        </button>
                                        {profile.referred.arrayValue.values.map(ele =>{
                                            return <Beneficiary 
                                                key={ele}
                                                imgUrl={head2}
                                                name="Sam"
                                                nam2="Pearl" />
                                        })}
                                    </div>
                                </span>
                            </div>
                        </div>
                    </div>
                    <AddBeneficiary />
                    <PayBeneficiary />
            </>
            )
        }
    }
}

export default Dashboard